import React from 'react'
import GameWeeks from '../../components/GameWeeks/GameWeeks';

const Matches = ({ children, page }) => {

    return (
        <React.Fragment>
            <GameWeeks />
            {page}
        </React.Fragment>
    )
}

export default Matches;